import { NgModule } from '@angular/core'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CleanUIModule } from './components/CleanUIComponents/cleanui.module'
import { SharedModule } from '../shared/shared.module'
import { CoreRoutingModule } from './core-routing.module'
import { LoginComponent } from './pages/auth/login/login.component'
import { ForgotComponent } from './pages/auth/forgot/forgot.component'
import { DashboardComponent } from './pages/dashboard/dashboard.component'
import { NotFoundComponent } from './pages/404.component';
import { MessageConfirmComponent } from './components/modals/message-confirm/message-confirm.component'

const COMPONENTS = [LoginComponent, ForgotComponent, DashboardComponent, NotFoundComponent, MessageConfirmComponent]
const EXPORTS_COMPONENTS = [ ];
const ENTRYCOMPONENTS = [MessageConfirmComponent]

@NgModule({
  declarations: [...COMPONENTS],
  imports: [SharedModule, CleanUIModule, FormsModule, ReactiveFormsModule, CoreRoutingModule],
  exports : [...EXPORTS_COMPONENTS],
  entryComponents : [...ENTRYCOMPONENTS]
})
export class CoreModule {}
